export const DOCUMENT_UPLOADING_START = 'DOCUMENT_UPLOADING_START'
export const DOCUMENT_UPLOADING_END = 'DOCUMENT_UPLOADING_END'

export function startDocumentUploading() {
  return dispatch => {
    dispatch({
      type: DOCUMENT_UPLOADING_START,
      payload: {
        isUploading: true,
      },
    })
  }
}
export function endDocumentUploading() {
  return dispatch => {
    dispatch({
      type: DOCUMENT_UPLOADING_END,
      payload: {
        isUploading: false,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/AppAction.js